<template>
  <li class="layout-topbar-item nc-item">
    <a class="layout-topbar-action flex flex-row justify-content-center align-items-center px-3 p-ripple"
      @click="toggle" v-ripple>
      <i class="pi pi-bell nc-icon"></i>
      <span v-if="noLeidas > 0" class="nc-badge">{{ noLeidas > 9 ? '9+' : noLeidas }}</span>
    </a>

    <OverlayPanel ref="op" class="nc-panel">
      <div class="nc-panel-header">
        <span class="nc-panel-titulo">Notificaciones</span>
        <button v-if="noLeidas > 0" class="nc-btn-link" @click="marcarTodasLeidas">
          Marcar todas como leídas
        </button>
      </div>

      <div v-if="cargando" class="nc-panel-empty">
        <i class="pi pi-spin pi-spinner mr-2"></i> Cargando…
      </div>

      <div v-else-if="!notificaciones.length" class="nc-panel-empty">
        <i class="pi pi-bell-slash mr-2"></i> No tienes notificaciones
      </div>

      <ul v-else class="nc-lista">
        <li v-for="n in notificaciones" :key="n.id"
          class="nc-notif" :class="{ 'nc-notif--no-leida': !n.read_at }"
          @click="marcarLeida(n)">
          <i class="pi nc-notif-icon" :class="n.data.estado === 'ERROR' ? 'pi-times-circle nc-icon--error' : 'pi-check-circle nc-icon--ok'"></i>
          <div class="nc-notif-body">
            <div class="nc-notif-titulo">{{ n.data.titulo }}</div>
            <div class="nc-notif-msg">{{ n.data.mensaje || n.data.identificador }}</div>
            <div class="nc-notif-fecha">{{ formatFecha(n.created_at) }}</div>
          </div>
        </li>
      </ul>
    </OverlayPanel>
  </li>
</template>

<script>
export default {
  name: 'NotificacionesCampana',

  data() {
    return {
      notificaciones: [],
      noLeidas: 0,
      cargando: false,
      pollingTimer: null,
    };
  },

  mounted() {
    this.cargar();
    this.pollingTimer = setInterval(this.cargar, 25000);
  },

  beforeUnmount() {
    if (this.pollingTimer) clearInterval(this.pollingTimer);
  },

  methods: {
    toggle(event) {
      this.$refs.op.toggle(event);
    },

    cargar() {
      this.cargando = this.notificaciones.length === 0;
      window.api.call('post', '/cargar_notificaciones', {}).then((response) => {
        if (response.status === 200) {
          this.notificaciones = response.data.data ?? [];
          this.noLeidas = response.data.no_leidas ?? 0;
        }
      }).catch(() => { /* polling silencioso */ }).finally(() => {
        this.cargando = false;
      });
    },

    marcarLeida(n) {
      if (n.read_at) return;
      window.api.call('post', '/marcar_notificacion_leida', { id: n.id }).then(() => {
        n.read_at = new Date().toISOString();
        this.noLeidas = Math.max(0, this.noLeidas - 1);
      }).catch(() => {});
    },

    marcarTodasLeidas() {
      window.api.call('post', '/marcar_todas_notificaciones_leidas', {}).then(() => {
        this.notificaciones.forEach(n => { n.read_at = n.read_at || new Date().toISOString(); });
        this.noLeidas = 0;
      }).catch(() => {});
    },

    formatFecha(f) {
      if (!f) return '';
      const d = new Date(f);
      return d.toLocaleString('es-CO', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
    },
  },
};
</script>

<style scoped lang="scss">
$navy:#0A354E; $g200:#e8eaed; $g500:#6b7280; $g700:#374151;

.nc-item { position: relative; }
.nc-icon { font-size: 1.3rem; }
.nc-badge {
  position: absolute; top: 6px; right: 6px;
  background: #dc2626; color: #fff; font-size: .65rem; font-weight: 700;
  min-width: 16px; height: 16px; border-radius: 8px;
  display: flex; align-items: center; justify-content: center; padding: 0 3px;
}

.nc-panel { width: 340px; max-width: 90vw; }
.nc-panel-header { display: flex; justify-content: space-between; align-items: center; padding: .5rem .25rem .75rem; border-bottom: 1px solid $g200; }
.nc-panel-titulo { font-weight: 700; color: $navy; font-size: .9rem; }
.nc-btn-link { background: none; border: none; color: $navy; font-size: .72rem; font-weight: 600; cursor: pointer; &:hover { text-decoration: underline; } }
.nc-panel-empty { padding: 1.5rem .5rem; text-align: center; color: #94a3b8; font-size: .85rem; }

.nc-lista { list-style: none; margin: 0; padding: 0; max-height: 360px; overflow-y: auto; }
.nc-notif { display: flex; gap: .6rem; padding: .65rem .35rem; border-bottom: 1px solid #f1f3f4; cursor: pointer; &:hover { background: #f8f9fa; } }
.nc-notif--no-leida { background: #eff6ff; &:hover { background: #dbeafe; } }
.nc-notif-icon { font-size: 1.1rem; margin-top: 2px; }
.nc-icon--ok { color: #16a34a; }
.nc-icon--error { color: #dc2626; }
.nc-notif-body { flex: 1; min-width: 0; }
.nc-notif-titulo { font-size: .82rem; font-weight: 700; color: $g700; }
.nc-notif-msg { font-size: .78rem; color: $g500; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
.nc-notif-fecha { font-size: .68rem; color: #94a3b8; margin-top: 2px; }
</style>
